$(() => {
  if (window.location.href.indexOf('/services')) {
    $('.third-screen').css('opacity', 1)

    window.setTimeout(function () {
      $('.letter-services').each((i, e) => {
        console.log(e)
        setTimeout(function () {
          $(e).addClass('animate')
        }, i * 20)
      })
    }, 500)

    setTimeout(function () {
      $('.reveal-row').css('opacity', 1)

      $('.reveal-row').find('a').each((i, e) => {
        setTimeout(function () {
          $(e).css('opacity', 1)
        }, i * 350)
      })
    }, 2500)
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/_servicesSectionAnimation.js